import styled from "styled-components";
import { motion } from "framer-motion";

export const ConfirmarMedicoSolicitanteContainer = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  h1 {
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    width: 90%;
    .bold {
      font-weight: bold;
    }
  }
`;
